import React from "react";

const AboutSection = () => {
  const aboutContent = [
    {
      img: "fa-solid fa-address-card",
      title: "Verify Your Identity",
      content:
        "Complete The Identity Verification Process To Secure Your Account And Transactions.",
    },
    {
      img: "fa-solid fa-address-book",
      title: "Fund Your Account",
      content:
        "Add Funds To Your Crypto Account To Start Trading Crypto. You Can Add Funds With A Variety Of Payment Methods..",
    },
    {
      img: "fa-regular fa-message",
      title: "Start Trading",
      content:
        "Complete The Identity Verification Process To Secure Your Account And Transactions.",
    },
  ];
  return (
    <div className="about-section section-padding" id="about">
      <div className="container">
        <div className="row g-4">
          {/* ABOUT IMAGE SECTION */}
          <div className="col-lg-5 pe-lg-5">
            <div className="about-img d-flex justify-content-center" data-aos='zoom-in'>
              <img
                src="/image/about/about-img.jpg"
                className="rounded-5 img-fluid"
                alt=""
              />
            </div>
          </div>
          {/* ABOUT CONTENT SECTION */}
          <div className="col-lg-7 px-lg-5 mt-lg-0 mt-5">
            <div className="about-content">
              <h2 className="text-white" data-aos='fade-up'>
                Create Your Cryptocurrency Portfolio Today
              </h2>
              <p className="mt-md-5 mt-4 mb-5" data-aos='fade-up'>
                Start Your First Trade With These Easy Steps.
              </p>
              {aboutContent.map((element, index) => {
                return (
                  <div
                    key={index}
                    className="about-detail d-flex align-items-start gap-4 mb-md-5 mb-4 "
                    data-aos='fade-up' data-aos-anchor-placement="center-bottom"
                  >
                    <div className="detail">
                      <i className={element.img}></i>
                    </div>
                    <div className="about-detail-content">
                      <h3 className="text-white">{element.title}</h3>
                      <p className="mt-4">{element.content}</p>
                    </div>
                  </div>
                );
              })}
              <button data-aos='zoom-in' className="btn btn-primary d-inline-block  mt-4">get started</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
